/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/**
 =========================================================
 COMPONENTS FOR Gestione Interventi
 =========================================================
 Heavly modified by www.stefanofrasca.com | @fefoweb

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */
import React from 'react';
// import TextField from '@material-ui/core/TextField';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import { Controller } from 'react-hook-form';
import {InputLabel, MenuItem, Select} from '@mui/material';
// import { makeStyles } from '@mui/styles';

import PropTypes from 'prop-types';
import {styled} from "@mui/material/styles";

/*const useStyles = makeStyles({
  option: {
    fontSize: 15,
    '& > span': {
      marginRight: 10,
      fontSize: 18,
    },
  },
});*/

// Wrapper styled per la Select
const StyledSelect = styled(Select)(({ theme }) => ({
  // Personalizza i tuoi stili qui
  borderRadius: '8px',
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.primary,
  '& .MuiSelect-select': {
    padding: theme.spacing(0.8),
  },
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
  '&.Mui-focused': {
    borderColor: theme.palette.primary.main,
    boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
  },
}));

export default function RHSelect({
  options,
  formName = 'item',
  defaultValue,
  label,
  withLabel = true
}) {
  const renderItem = options.map((el) => (
    <MenuItem value={el.id} key={`${formName}_${el.id}`}>
      {el.label}
    </MenuItem>
  ));

  return (
    <>
      {!!withLabel && <InputLabel id="demo-simple-select-label" sx={{ left: 0 }}>{label}</InputLabel>}
      <StyledSelect onChange={() => {}} value={defaultValue}>
          {renderItem}
      </StyledSelect>
    </>
  );
}

RHSelect.propTypes = {
  options: PropTypes.any.isRequired,
  formName: PropTypes.string,
  defaultValue: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
  withLabel: PropTypes.bool
};
